import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import { useEffect } from "react";

const About = () => {
  // Добавляем структурированные данные для раздела "О нас"
  useEffect(() => {
    const aboutStructuredData = {
      "@context": "https://schema.org",
      "@type": "Article",
      headline: "О нашей усадьбе",
      description:
        "Лесная Усадьба — это уютное пространство для фотосессий в Подмосковье, созданное с любовью к деталям и природе.",
      image: "/thumbnails/дача_столик_7-md.jpg",
      author: {
        "@type": "Person",
        name: "Лесная Усадьба",
      },
      publisher: {
        "@type": "Organization",
        name: "Лесная Усадьба",
        logo: {
          "@type": "ImageObject",
          url: "https://fotodacha.ru/favicon/android-icon-192x192.png",
        },
      },
      datePublished: "2023-07-01",
      dateModified: "2025-07-02",
      mainEntityOfPage: {
        "@type": "WebPage",
        "@id": "https://fotodacha.ru/#about",
      },
      keywords:
        "фотолокация, фотосессия, Подмосковье, Солнечногорский район, Московская область, farmhouse, cottagecore, аренда локации",
    };

    // Добавляем структурированные данные
    let scriptTag = document.querySelector("#about-structured-data");
    if (!scriptTag) {
      scriptTag = document.createElement("script");
      scriptTag.id = "about-structured-data";
      scriptTag.type = "application/ld+json";
      document.head.appendChild(scriptTag);
    }
    scriptTag.textContent = JSON.stringify(aboutStructuredData);

    return () => {
      if (scriptTag && document.head.contains(scriptTag)) {
        document.head.removeChild(scriptTag);
      }
    };
  }, []);

  return (
    <section id="about" className="section bg-white">
      <div className="container">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 items-center">
          <div className="about-content">
            <h2 className="mb-6 text-3xl font-bold font-serif header-color md:text-4xl">
              О нашей усадьбе
            </h2>
            <p className="mb-4 text-gray-700">
              Лесная Усадьба — это уютное пространство для фотосессий, созданное
              с любовью к деталям и природе. Расположенная в живописном месте,
              наша локация предлагает аутентичную атмосферу загородного дома в
              стиле фармхаус в окружении леса, и сада непрерывного цветения.
            </p>
            <p className="mb-4 text-gray-700">
              Вы хотите провести мастер-класс, йога-сессию, встречу книжного
              клуба или другое камерное мероприятие на свежем воздухе или в
              дачных стенах? Будем рады видеть вас у нас в гостях — мы находимся
              в Солнечногорском районе Московской области, в полу часе езды от
              города.
            </p>
            {/* <a
              href="#booking"
              className="inline-block px-8 py-3 text-white transition-colors duration-300 rounded-md bg-terracotta hover:bg-terracotta-90 shadow-md hover:shadow-lg"
            >
              Забронировать
            </a> */}
          </div>

          <div className="about-image">
            <Splide
              options={{
                type: "loop",
                autoplay: true,
                interval: 3000,
                pauseOnHover: true,
                arrows: true,
                pagination: true,
                height: "400px",
                classes: {
                  arrows: "splide__arrows custom-arrows",
                  arrow: "splide__arrow custom-arrow",
                  prev: "splide__arrow--prev custom-prev",
                  next: "splide__arrow--next custom-next",
                },
              }}
            >
              <SplideSlide>
                <img
                  src="/thumbnails/дача_столик_7-md.jpg"
                  alt="Интерьер усадьбы"
                  className="w-full h-full object-cover"
                  width="600"
                  height="400"
                />
              </SplideSlide>
              <SplideSlide>
                <img
                  src="/thumbnails/дача_грядка_7-md.jpg"
                  alt="Экстерьер усадьбы"
                  className="w-full h-full object-cover"
                  width="600"
                  height="400"
                />
              </SplideSlide>
              <SplideSlide>
                <img
                  src="/thumbnails/дача_дом_2-md.jpg"
                  alt="Детали интерьера усадьбы в Подмосковье"
                  className="w-full h-full object-cover"
                  width="600"
                  height="400"
                />
              </SplideSlide>
              <SplideSlide>
                <img
                  src="/thumbnails/дача_мольберт_8-md.jpg"
                  alt="Детали интерьера фотолокации в Московской области"
                  className="w-full h-full object-cover"
                  width="600"
                  height="400"
                />
              </SplideSlide>
            </Splide>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
